import useEmblaCarousel from "embla-carousel-react";
import BotaoWrapper from "../components/BotaoWrapper";
import DelayedLinkWithFadeout from "../components/utils/DelayedLinkWithFadeout";
import Fade from "../components/Fade";
import { useEffect, useState } from "react";
import LogoFooter from "../components/LogoFooter";

const Atendimentos = () => {
  const [cards, setCards] = useState([]);
  const normalizeText = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/^['\"]|['\"]$/g, "");

  const localTotem = normalizeText(process.env.REACT_APP_LOCAL_TOTEM);
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "start",
    dragFree: true,
  });

  const [activeIndex, setActiveIndex] = useState(0);
  const [originalLength, setOriginalLength] = useState(0);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/temas`)
      .then((r) => r.json())
      .then((data) => {
        const filtrados = data.filter((a) => {
          const temImagem = a?.imagem != null;
          const localItem = normalizeText(a?.local);
          const localValido = localItem === "todos" || localItem === localTotem;

          return temImagem && localValido;
        });

        setOriginalLength(filtrados.length);

        setCards(filtrados);
      });
  }, []);

  const getCardRoute = (atendimento) => {
    if (atendimento?.rota_id && atendimento?.rota) {
      return atendimento.rota.startsWith("/")
        ? atendimento.rota
        : `/${atendimento.rota}`;
    }

    if (atendimento?.rota) {
      return atendimento.rota.startsWith("/")
        ? atendimento.rota
        : `/${atendimento.rota}`;
    }

    return `/atendimento/${atendimento.id}/info`;
  };

  const snaps = emblaApi?.scrollSnapList() || [];

  useEffect(() => {
    if (!emblaApi) return;

    const update = () => {
      if (!emblaApi) return;

      const snapList = emblaApi.scrollSnapList();
      const selected = emblaApi.selectedScrollSnap();

      setActiveIndex(selected % snapList.length);
    };

    emblaApi.on("select", update);
    emblaApi.on("reInit", update);

    update();
  }, [emblaApi, originalLength]);

  return (
    <Fade>
      <div className="min-h-screen flex flex-col overflow-hidden touch-pan-y">
        <div className="py-8 pl-16 text-5xl text-deepBlue font-tommy pt-16">
          <strong>Terminal de Atendimento SVMA</strong>
        </div>

        <div className="overflow-hidden" ref={emblaRef}>
          <div className="flex gap-8 px-10">
            {cards.map((atendimento, index) => (
              <div key={`${atendimento.id}-${index}`} className="flex-shrink-0">
                {/* {atendimento.local === "externo" && atendimento.link ? 
                  <a rel="stylesheet" href={atendimento.link}>
                    <BotaoWrapper
                      ImgName={atendimento.imagem}
                      titulo={atendimento.nome}
                      subtitulo={
                        atendimento.descricao ||
                        atendimento.sistemas?.[0]?.sobre ||
                        "Descrição indisponível"
                      }
                      cor={atendimento.cor || "#217cb5"}
                      onClick={invoke('abre_janela', {url: atendimento.link,})}
                    />
                  </a>
                  :
                  <DelayedLinkWithFadeout to={getCardRoute(atendimento)}> 
                    <BotaoWrapper
                      ImgName={atendimento.imagem}
                      titulo={atendimento.nome}
                      subtitulo={
                        atendimento.descricao ||
                        atendimento.sistemas?.[0]?.sobre ||
                        "Descrição indisponível"
                      }
                      cor={atendimento.cor || "#217cb5"}
                    />
                  </DelayedLinkWithFadeout> 
                } */}

                <DelayedLinkWithFadeout to={getCardRoute(atendimento)}> 
                    <BotaoWrapper
                      ImgName={atendimento.imagem}
                      titulo={atendimento.nome}
                      subtitulo={
                        atendimento.descricao ||
                        atendimento.sistemas?.[0]?.sobre ||
                        "Descrição indisponível"
                      }
                      cor={atendimento.cor || "#217cb5"}
                      onClick={console.log(atendimento.link)}
                    />
                  </DelayedLinkWithFadeout> 
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-center items-center gap-3 mt-10 py-3">
          {snaps.map((_, index) => (
            <button
              key={index}
              onClick={() => emblaApi?.scrollTo(index)}
              className={`
                rounded-full transition-all duration-300
                ${
                  index === activeIndex
                    ? "w-5 h-5 bg-deepBlue scale-90"
                    : "w-3 h-3 bg-grayLight"
                }
              `}
            />
          ))}
        </div>

        <div className="bg-white w-full mt-auto">
          <div className="max-w-[1280px] mx-auto flex justify-between items-center">
            <DelayedLinkWithFadeout to="/">
              <button className="min-w-[200px] py-4 border-2 border-deepBlue text-deepBlue px-12 rounded-2xl text-3xl font-semibold">
                Voltar
              </button>
            </DelayedLinkWithFadeout>

            <div className="p-6">
              <LogoFooter />
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default Atendimentos;
